import React from 'react';
import Icon from '@pushpay/icon';
import { clsx, createUseStyles } from '@pushpay/styles';
import { GivingTheme, isGivingOldTheme } from '@pushpay/theming';
const useStyles = createUseStyles(theme => ({
  root: {
    color: isGivingOldTheme(theme) ? '#E51B00' : GivingTheme.colors['product-color']
  }
}));

const CustomerAdminPortalIcon = ({
  classes: classesProp,
  className: classNameProp,
  ...rest
}) => {
  const classes = useStyles(classesProp);
  const className = clsx(classNameProp, classes.root);
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24",
    className: className
  }, rest), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 24,
    height: 24,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.322 4.484v3.748h2.608v11.246h2.608V4.484z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    opacity: 0.3,
    d: "M8.07 15.73H5.462v3.748h5.216V15.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    opacity: 0.7,
    d: "M13.322 8.232h-2.606v3.748h2.568v7.498h2.646V8.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    opacity: 0.5,
    d: "M10.716 11.98H8.07v3.75h2.608v3.748h2.606V11.98z"
  }));
};

export default CustomerAdminPortalIcon;